import { defineStore } from 'pinia'
import { VideoStore } from '@/front/stores/video_store.js'

export const DesignStore = defineStore('designs', {
  state: () => {
    return {
      loading: true,
      saving: false,
      showSavingAnimation: false,
      design: {},
      pagination: {page: 1}
    }
  },

  actions: {

    async show(video_id=null, group_id=null) {
      // log.info(3,"🌜 DesignStore show", video_id, group_id)
      this.loading = true
      return this.Api.get(`/designs?video_id=${video_id||''}&group_id=${group_id||''}`).then(response => {  
        this.design = response.data.design;        
      }).finally(() => {
        this.loading = false
      })
    },
    async update() {
      this.saving = true
      this.showSavingAnimation = true
      const videoStore = VideoStore()
      
      log.info(5, "🌜 DesignStore update - sending design with custom_font:", {
        id: this.design.id,
        font_family: this.design.font_family,
        custom_font: this.design.custom_font
      })
      
      return this.Api.put(`/designs/${this.design.id}`, { design: this.design }).then(response => {  
        log.info(5, "🌜 DesignStore update - response:", response.data.design)
        this.design = response.data.design;   
        videoStore.video.design = this.design
        document.documentElement.style.setProperty('--user-theme-color', this.design.color)     
      }).finally(() => {
        this.saving = false
        setTimeout(() => {
          this.showSavingAnimation = false
        }, 1500)
      })
    },

    async applyGroupDesign(group_id) {
      log.info(3,"🌜 DesignStore applyGroupDesign", group_id)
      return this.Api.post(`/designs/group_apply/${group_id}`).then(response => {
        log.info(3,"🔊 DesignStore applyGroupDesign done")
      })
    },

    async applyAccountDesign(videoIds) {
      log.info(3,"🌜 DesignStore applyAccountDesign", videoIds)
      return this.Api.post('/designs/account_apply', { video_ids: videoIds }).then(response => {
        log.info(3,"🔊 DesignStore applyAccountDesign done")
      })
    },

    async importDesign(source, argument, options = {}) {
      log.info(3,"🌜 DesignStore importDesign", source, argument, options)
      return this.Api.post(`/designs/${this.design.id}/import`, {
        source: source,
        argument: argument,
        overwrite_custom_styles: !!options.overwriteCustomStyles
      }).then(response => {
        log.info(3,"🔊 DesignStore importDesign done", response.data.design)
        this.design = response.data.design
        const videoStore = VideoStore()
        if (videoStore.video?.id) {
          videoStore.video.design = this.design
        }
      })
    },

    async updateMagicMenu() {
      this.saving = true
      this.showSavingAnimation = true

      return this.Api.put(`/trays/${this.design.magic_menu.id}`, this.design.magic_menu).then(response => { 
        log.info(3,"🔊 DesignStore updateMagicMenu done", response.data)
        this.design.magic_menu = response.data.tray;        
      }).finally(() => {
        this.saving = false
        setTimeout(() => {
          this.showSavingAnimation = false
        }, 1500)
      })
    },

    async updateEndMenu() {
      this.saving = true
      this.showSavingAnimation = true
      return this.Api.put(`/trays/${this.design.end_menu.id}`, this.design.end_menu).then(response => {  
        this.design.end_menu = response.data.tray;        
      }).finally(() => {
        this.saving = false
        setTimeout(() => {
          this.showSavingAnimation = false
        }, 1500)
      })
    },

    async destroy(id) {      
      return this.Api.destroy(`/designs/${id}`).then(response => {  
        this.errors = {};
      }).catch(error => {
        this.errors = error.response.data.errors;
      }) 
    }
  }
})
